import { getEncodedParams } from 'helpers/encodeParams';

exports.socialCampaignsEndpoint = (state, params) => {
    const encodedParams = getEncodedParams(state);
    return `${state.config.apiUrl}/v1/entity/${params.entityId}/social/campaigns?start=${encodedParams.start}&end=${encodedParams.end}`;
};

exports.socialCampaignsByObjectiveEndpoint = (state, params) => {
    const encodedParams = getEncodedParams(state);
    return `${state.config.apiUrl}/v1/entity/${params.entityId}/social/campaigns?start=${encodedParams.start}&end=${encodedParams.end}&objective=${params.objective}`;
};

exports.socialAdSetsEndpoint = (state, params) => {
    const encodedParams = getEncodedParams(state);
    return `${state.config.apiUrl}/v1/entity/${params.entityId}/social/adsets?start=${encodedParams.start}&end=${encodedParams.end}`;
};

exports.socialAdSetsByObjectiveEndpoint = (state, params) => {
    const encodedParams = getEncodedParams(state);
    return `${state.config.apiUrl}/v1/entity/${params.entityId}/social/adsets?start=${encodedParams.start}&end=${encodedParams.end}&objective=${params.objective}`;
};

exports.socialAdsEndpoint = (state, params) => {
    const encodedParams = getEncodedParams(state);
    return `${state.config.apiUrl}/v1/entity/${params.entityId}/social/ads?start=${encodedParams.start}&end=${encodedParams.end}`;
};

exports.socialAdsByObjectiveEndpoint = (state, params) => {
    const encodedParams = getEncodedParams(state);
    return `${state.config.apiUrl}/v1/entity/${params.entityId}/social/ads?start=${encodedParams.start}&end=${encodedParams.end}&objective=${params.objective}`;
};

exports.socialCalloutsByObjectiveEndpoint = (state, params) => {
    const encodedParams = getEncodedParams(state);
    return `${state.config.apiUrl}/v1/entity/${params.entityId}/channel/social/callouts?start=${encodedParams.start}&end=${encodedParams.end}&objective=${params.objective}`;
};

exports.socialDataByObjectiveEndpoint = (state, params) => {
    const encodedParams = getEncodedParams(state);
    return `${state.config.apiUrl}/v1/entity/${params.entityId}/channel/social?start=${encodedParams.start}&end=${encodedParams.end}&objective=${params.objective}`;
};

exports.socialActionsEndpoint = (state, params) => {
    const encodedParams = getEncodedParams(state);
    return `${state.config.apiUrl}/v1/entity/${params.entityId}/social/actions/summary?start=${encodedParams.start}&end=${encodedParams.end}`;
};

exports.socialActionsByObjectiveEndpoint = (state, params) => {
    const encodedParams = getEncodedParams(state);
    return `${state.config.apiUrl}/v1/entity/${params.entityId}/social/actions/summary?start=${encodedParams.start}&end=${encodedParams.end}&objective=${params.objective}`;
};

exports.socialDemographicsEndpoint = (state, params) => {
    const encodedParams = getEncodedParams(state);
    return `${state.config.apiUrl}/v1/entity/${params.entityId}/social/demographics/summary?start=${encodedParams.start}&end=${encodedParams.end}`;
};

exports.socialDemographicsByObjectiveEndpoint = (state, params) => {
    const encodedParams = getEncodedParams(state);
    return `${state.config.apiUrl}/v1/entity/${params.entityId}/social/demographics/summary?start=${encodedParams.start}&end=${encodedParams.end}&objective=${params.objective}`;
};

exports.socialUniqueMeasuresEndpoint = (state, params) => {
    const encodedParams = getEncodedParams(state);
    const query = [
        `start=${encodedParams.start}`,
        `end=${encodedParams.end}`
    ];
    if (params.grain) {
        query.push(`grain=${params.grain}`);
    }
    return `${state.config.apiUrl}/v1/entity/${params.entityId}/social/measures/unique?${query.join('&')}`;
};

exports.socialUniqueMeasuresByObjectiveEndpoint = (state, params) => {
    const encodedParams = getEncodedParams(state);
    const query = [
        `start=${encodedParams.start}`,
        `end=${encodedParams.end}`,
        `objective=${params.objective}`
    ];
    if (params.grain) {
        query.push(`grain=${params.grain}`);
    }
    return `${state.config.apiUrl}/v1/entity/${params.entityId}/social/measures/unique?${query.join('&')}`;
};



// WEBPACK FOOTER //
// ./src/services/social/selectors.js